/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductGroupsResponse as ModelsProductProductGroupsResponse } from '../../models/Models/Product/product-groups-response';

export interface V3ProductsProductGroupsGet$Plain$Params {
}

export function v3ProductsProductGroupsGet$Plain(http: HttpClient, rootUrl: string, params?: V3ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ProductsProductGroupsGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsProductProductGroupsResponse>;
    })
  );
}

v3ProductsProductGroupsGet$Plain.PATH = '/v3/products/productGroups';
